import { enqueueSnackbar, SnackbarKey, closeSnackbar } from "notistack";
import { X } from "react-bootstrap-icons";

export const showNotification = (contactName: string, message: string, onClick: () => void) => {
  enqueueSnackbar("", {
    variant: "default",
    autoHideDuration: 4000,
    content: (key: SnackbarKey) => (
      <div onClick={onClick} className="position-relative d-flex align-items-center py-1 ps-2 pe-4 bg-secondary-subtle">
        <button
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            closeSnackbar(key)
          }}
          style={{
            position: "absolute",
            top: "0px",
            right: "6px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <X size={16} />
        </button>

        <div
          className="d-flex justify-content-center align-items-center rounded-circle bg-secondary text-white"
          style={{
            width: 40,
            height: 40,
            fontWeight: "bold",
            fontSize: "1rem",
          }}
        >
          {contactName[0]?.toUpperCase()}
        </div>

        <div className="ms-2">
          <div style={{ fontWeight: 600, lineHeight: "normal" }}>
            {String(contactName)}
          </div>
          <div>{message}</div>
        </div>
      </div>
    ),
  });

  if ("Notification" in window) {
    if (Notification.permission === "granted") {
      if (document.hidden) {
        new Notification(contactName, {
          body: message,
          icon: "/icon.png",
        });
      }
    }
  }

};
